// Clarity
$(document).ready(function(){

  $(".site-nav__dropdown-link:contains('Space')").css("color", "white");
  $('.m09').parent('div').addClass('m09-parent');
  $(".site-nav__dropdown-link:contains('Space')").addClass("space-nav");
  $(".mobile-nav__link:contains('Space')").addClass("space-nav");

  //   if ($('.site-header-sticky').hasClass("site-header")) {
  //     $('.icon__fallback-text').css({"position":"relative"});
  //   }

  //     $('#AnnouncementSlider').slick({
  //       adaptiveHeight: true,
  //       autoplay: true,
  //       autoplaySpeed: 5000
  // 	});

  $('.m04-slider').slick({
    slidesToShow: 4,
    slidesToScroll: 4,
    infinite: false,
    arrows: true,
    dots: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
          dots: false
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }

    ]
  });
  
  $('.sample-slider').slick({
    slidesToShow: 4,
    slidesToScroll: 4,
    infinite: false,
    arrows: true,
    dots: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
          dots: false
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }

    ]
  });


  $('.m02-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: false,
    adaptiveHeight: true,
    autoplay: false,
    autoplaySpeed: 5000,
    arrows: true,
    dots: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          adaptiveHeight: true,
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }

    ]
  });




  $(".feature-ingredient-image").hover(function(){
    $( this ).addClass( "hover" );
    $('.feature-ingredient[data-ingredient="'+$( this ).attr("data-ingredient")+'"]').addClass('hover');
  }, function(){
    $( this ).removeClass( "hover" );
    $('.feature-ingredient[data-ingredient="'+$( this ).attr("data-ingredient")+'"]').removeClass('hover');
  });

  $(".feature-ingredient").hover(function(){
    $( this ).addClass( "hover" );
    $('.feature-ingredient-image[data-ingredient="'+$( this ).attr("data-ingredient")+'"]').addClass('hover');
  }, function(){
    $( this ).removeClass( "hover" );
    $('.feature-ingredient-image[data-ingredient="'+$( this ).attr("data-ingredient")+'"]').removeClass('hover');
  });


  if ($(window).width() >= 800){	
    // do something here
    $('.product__thumbs').insertAfter('.product-single__sku');
  }	


  $('#addall').click(function() {
    console.log('addall');
    var productJSON = [];
    $('.product-routine .grid-product').each(function() {
      var product = JSON.parse($(this).find('.product-grid-item-json').first().text().replace(/\n\r\t/g, "").replace(/\s{2,}/g,'').replace(/,(\s*,|\s*})/g, '$1'));
      productJSON.push({ quantity: 1, id: product.id, properties: product.properties })
    })

    $('#addall').addClass('btn--loading');

    var xhr = new XMLHttpRequest();
    xhr.open("POST", '/cart/add.js', true);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.send(JSON.stringify({
      items: productJSON}))
    xhr.onload = function() {
      $('#addall').removeClass('btn--loading');
      $('body').trigger('added.ajaxProduct', this.$addToCart);
      updateCartCount();
    };
  })

  $('.grid-product__link').on('click', function(e) {
   
     
    if($(e.target).hasClass('add-grid-item')) {
      e.preventDefault();
      if($(e.target).attr('disabled')){
        
      } else {
        let anchorTag = this;
        
        const quantityLimitElem = $(this).find('[data-quantity-limit]');
        let quantityLimit = 0;
        let itemCartQuantity = 0;
        let updatedItemCartQuantity = 0;
        let variantId = '0';
        let requestType = 'add';
        let proceed = true;

        if (quantityLimitElem.length > 0) {
          quantityLimit = quantityLimitElem.attr('data-quantity-limit') || 30;
          itemCartQuantity = quantityLimitElem.attr('data-item-cart-quantity');
          variantId = quantityLimitElem.attr('data-variant-id');
          requestType = quantityLimitElem.attr('data-request-type');
        
          if (quantityLimit === 0) {
            proceed = false;
          }
        }

        if (proceed) {
          updatedItemCartQuantity = parseInt(itemCartQuantity) + 1;

          $(this).find('[data-add-grid-item]').first().addClass('btn--loading');
          const product = JSON.parse($(this).find('.product-grid-item-json').text().replace(/\n\r\t/g, "").replace(/\s{2,}/g,'').replace(/,(\s*,|\s*})/g, '$1'));

          let xhr = new XMLHttpRequest();
          if (requestType === 'add') {
            xhr.open("POST", '/cart/add.js', true);
            xhr.setRequestHeader('Content-Type', 'application/json');
            xhr.send(JSON.stringify({
              items: [product]
            }))
          } else {
            let updates = {};
            updates[variantId] = updatedItemCartQuantity;

            xhr.open("POST", '/cart/update.js', true);
            xhr.setRequestHeader('Content-Type', 'application/json');
            xhr.send(JSON.stringify({
              updates: updates
            }))
          }
          
          xhr.onload = function() {
            if($(e.target).text() == 'Pick'){
              location.reload();
            } else {
              $(anchorTag).find('[data-add-grid-item]').first().removeClass('btn--loading');
              $('body').trigger('added.ajaxProduct', this.$addToCart);
              updateCartCount();

              let newLimit = quantityLimit - 1;
              quantityLimitElem.attr('data-quantity-limit', newLimit);
              quantityLimitElem.attr('data-item-cart-quantity', updatedItemCartQuantity);

              if (requestType === 'add') {
                quantityLimitElem.attr('data-request-type', 'update');
              }

              if (newLimit === 0) {
                quantityLimitElem.addClass('btn-no-stock');
                quantityLimitElem.attr('disabled', true);
              }
            }
          };	
        }
      }
     
    }  else {
        console.log('false')
      }
  })

  $('.add-to-bag').on('click', function(){
    $(this).addClass('btn--loading');
    var anchorTag = this;
    var productJSON = [{ quantity: 1, id: $(this).attr('data-product-variant-id') }];
    var xhr = new XMLHttpRequest();
    xhr.open("POST", '/cart/add.js', true);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.send(JSON.stringify({
      items: productJSON}))
    xhr.onload = function() {
      $(anchorTag).removeClass('btn--loading');
      $('body').trigger('added.ajaxProduct', this.$addToCart);
      updateCartCount();
    };	
  })

  const updateCartCount = async() => {
    const cart = await getCart();
    const cartBubble = '.cart-link__bubble';
    if (cart.items.length > 0) {
      $(cartBubble).addClass('cart-link__bubble--visible');
    } else {
      $(cartBubble).removeClass('cart-link__bubble--visible');
    }
    $(cartBubble).attr('data-items', cart.item_count);
  }

  const getCart = () => {
    return window.theme.cart.getCart().then((cart) => cart);
  }

  document.addEventListener("cart:build", function (event) {
    updateCartCount()
  });

  updateCartCount();
  	
});


!function(e){e.fn.shorten=function(s){"use strict";var t={showChars:100,minHideChars:10,ellipsesText:"...",moreText:"more",lessText:"less",onLess:function(){},onMore:function(){},errMsg:null,force:!1};return s&&e.extend(t,s),e(this).data("jquery.shorten")&&!t.force?!1:(e(this).data("jquery.shorten",!0),e(document).off("click",".morelink"),e(document).on({click:function(){var s=e(this);return s.hasClass("less")?(s.removeClass("less"),s.html(t.moreText),s.parent().prev().animate({height:"0%"},function(){s.parent().prev().prev().show()}).hide("fast",function(){t.onLess()})):(s.addClass("less"),s.html(t.lessText),s.parent().prev().animate({height:"100%"},function(){s.parent().prev().prev().hide()}).show("fast",function(){t.onMore()})),!1}},".morelink"),this.each(function(){var s=e(this),n=s.html(),r=s.text().length;if(r>t.showChars+t.minHideChars){var o=n.substr(0,t.showChars);if(o.indexOf("<")>=0){for(var a=!1,i="",h=0,l=[],c=null,f=0,u=0;u<=t.showChars;f++)if("<"!=n[f]||a||(a=!0,c=n.substring(f+1,n.indexOf(">",f)),"/"==c[0]?c!="/"+l[0]?t.errMsg="ERROR en HTML: the top of the stack should be the tag that closes":l.shift():"br"!=c.toLowerCase()&&l.unshift(c)),a&&">"==n[f]&&(a=!1),a)i+=n.charAt(f);else if(u++,h<=t.showChars)i+=n.charAt(f),h++;else if(l.length>0){for(j=0;j<l.length;j++)i+="</"+l[j]+">";break}o=e("<div/>").html(i+'<span class="ellip">'+t.ellipsesText+"</span>").html()}else o+=t.ellipsesText;var m='<div class="shortcontent">'+o+'</div><div class="allcontent">'+n+'</div><span><button type="button" class="morelink">'+t.moreText+"</button></span>";s.html(m),s.find(".allcontent").hide(),e(".shortcontent p:last",s).css("margin-bottom",0)}}))}}(jQuery);

$('.ingredients-list').shorten({
  showChars: 300,
  moreText: '了解更多',
  lessText: '縮短內容',
  onMore: function(){
    $('.ingredients-list .allcontent').attr('tabindex','-1').focus();
  }
});

$('.product-single__description-full').shorten({
  showChars: 300,
  moreText: '了解更多',
  lessText: '縮短內容',
  onMore: function(){
    $('.product-single__description-full .allcontent').attr('tabindex','-1').focus();
  }
});

$('.product-grid-description').shorten({
  showChars: 0,
  moreText: '了解更多',
  lessText: '縮短內容',
  onMore: function(){
    $('.product-single__description-full .allcontent').attr('tabindex','-1').focus();
  }
});


// handle links with @href started with '#' only
// $(document).on('click', 'a[href^="#"]', function(e) {
//     // target element id
//     var id = $(this).attr('href');

//     // target element
//     var $id = $(id);
//     if ($id.length === 0) {
//         return;
//     }

//     // prevent standard hash navigation (avoid blinking in IE)
//     e.preventDefault();

//     // top position relative to the document
//     var pos = $id.offset().top;

//     // animated top scrolling
//     $('body, html').animate({scrollTop: pos});
// });

$(".scrollTo").on('click', function(e) {
  e.preventDefault();
  var target = $(this).attr('href');
  $('html, body').animate({
    scrollTop: ($(target).offset().top)
  }, 2000);
});

$( '.mobile-nav__link[href$="mobile"]' ).parent('div').addClass('hide');
$( '.mobile-nav__link[href^="/products"]' ).parent('div').addClass('hide');
$( '.site-nav__dropdown-link.site-nav__dropdown-link--top-level[href^="/products"]' ).parent('div').addClass('hide');

// Cart page - Quantity
$('.cart__product-qty').on('change', function(){
  const itemKey = this.dataset.id;
  const cartItem = $('input[id*="cart_updates_' + itemKey + '"');

  const currentQuantity = parseInt(cartItem.val());
  const inventoryQuantity = parseInt(this.dataset.inventoryQuantity);

  if (currentQuantity > inventoryQuantity) {
    cartItem.val(inventoryQuantity);
  };

  $('.cart__update').click();
});

$('.cart__product-qty-button--decrement').on('click', function() {
  updateQuantity(this.dataset.itemKey, 'decrement');
});

$('.cart__product-qty-button--increment').on('click', function() {
  updateQuantity(this.dataset.itemKey, 'increment');
});

function updateQuantity(itemKey, operation) {
  if (!itemKey || !operation) {
    return;
  };

  const cartItem = $('input[id*="cart_updates_' + itemKey + '"');
  const currentQuantity = parseInt(cartItem.val());
  let nextQuantity = currentQuantity;

  if (operation === 'decrement') {
    if (currentQuantity === 1) {
      return;
    };

    nextQuantity = currentQuantity - 1;
  };

  if (operation === 'increment') {
    nextQuantity = currentQuantity + 1;
  };

  cartItem.val(nextQuantity).trigger("change");
};

function initDecrementQuantityButtons() {
  $('.cart__product-qty-button--decrement').each(function() {
    const cartItem = $('input[id*="cart_updates_' + this.dataset.itemKey + '"');
    const currentQuantity = parseInt(cartItem.val());
    
    if (currentQuantity === 1) {
      this.setAttribute('disabled', true);
    };
  });

  $('.cart__product-qty-button--increment').each(function() {
    const cartItem = $('input[id*="cart_updates_' + this.dataset.itemKey + '"');
    const currentQuantity = parseInt(cartItem.val());
    const inventoryQuantity = parseInt(cartItem.data('inventory-quantity'));
    
    if (currentQuantity >= inventoryQuantity) {
      this.setAttribute('disabled', true);
    };
  });
};

$(document).ready(function () {
    $("#eye").click(function () {
        if ($(".show-password").attr("type") === "password") {
            $(".show-password").attr("type", "text");
        } else {
            $(".show-password").attr("type", "password");
        }
    });
  

   $('.ajaxcart__quantity').find('input').on('change', function() {
     $('body').trigger('added.ajaxProduct');
  })
   $('.ajaxcart__quantity').find('.js-qty__adjust.js-qty__adjust--minus').on('click', function(){
      $('body').trigger('added.ajaxProduct');
   })
   $('.ajaxcart__quantity').find('.js-qty__adjust.js-qty__adjust--plus').on('click',function(){
      $('body').trigger('added.ajaxProduct');
   })
   
   let first_trigger = false;
  let drawer = 0;
//     $('body').on('updateCart.ajaxcart', function(){
//       console.log('update');
//       if(first_trigger) {
// //         if(!searchParams.has('drawer')) {
// //           if(!(searchParams.get('drawer') == "true" || searchParams.get('drawer') == true)) {
// //           	location.href = location.href + "?drawer=true";
// //         	console.log(`location.href = ${location.href}`);
// //           }
// //         }
//         drawer = drawer + 1;
//          localStorage.setItem("drawer", drawer);
        
//         if(localStorage.getItem("drawer") == null || localStorage.getItem("drawer") == ) {
//         	localStorage.setItem("drawer", 1);
//                 	location.reload();
//         }
        

//       } else {
//       	first_trigger = true;
//       }
//     })
    
// //     let searchParams = new URLSearchParams(window.location.search);
//   console.log(`searchParams = ${localStorage.getItem("drawer")}`);
// //   if(searchParams.has('drawer')) {
// //     if(searchParams.get('drawer') == "true" || searchParams.get('drawer') == true) {
// //       console.log(`searchParams.. = ${searchParams.get('drawer')}`);
// //     	 $('body').trigger('added.ajaxProduct');
// //       window.location.href = location.href.split('?')[0];
// //     }
//      if(localStorage.getItem("drawer") != null && localStorage.getItem("drawer") == 2) {
//      	 localStorage.setItem("drawer", 0);
//         $('body').trigger('added.ajaxProduct');
//      }
// //   }
  
  
  $('.sample-slider .sample-checkbox').change(function(){
    if($(this).is(':checked')){
       var productJSON = [{ quantity: 1, id:$(this).prop('id') }];
        var xhr = new XMLHttpRequest();
        xhr.open("POST", '/cart/add.js', true);
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.send(JSON.stringify({
          items: productJSON}))
        xhr.onload = function() {
             location.reload();
        };	

    } else {
      var productJSON = { };
      productJSON['' + $(this).prop('id')] = 0;
        var xhr = new XMLHttpRequest();
        xhr.open("POST", '/cart/update.js', true);
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.send(JSON.stringify({
          updates: productJSON}))
        xhr.onload = function() {
             location.reload();
        };	
    }
    }) 
});

var $p =$('.m19-summary-links p');
    $p.first().html(function(){
        return $p.map(function(){
            return $(this).html() ;
        }).get().join(' ')
    }).end().filter(':gt(0)').remove();

function ScrollToDivId(id) {
    $("div").removeClass("flashit");
    $("#" + id).addClass("flashit");
    $('html,body').animate({
        scrollTop: $("#" + id).offset().top
    }, 'slow');
}

$('#m09-select').on('change', function (e) {
    var optionSelected = $("option:selected", this);
    var valueSelected = this.value;
    ScrollToDivId(valueSelected);
});




$(document).scroll(function() {
  var y = $(this).scrollTop();
  if (y > 600) {
    $('#sticky-product-parent').fadeIn();
  } else {
    $('#sticky-product-parent').fadeOut();
  }
});


/***************** m09 spy ****************/
$(document).ready(function() {
  var section = document.querySelectorAll(".m09-parent");
  var sections = {};
  var i = 0;

  var sectionTags = [];
  $(".m09-parent").find('a').each(function(e){
    var id = $(this).prop('href').split("#")[1];
    var tagId = "#"+id;
    sections[id] = $(tagId).parent().parent().offset().top;
  });

  window.onscroll = function() {
    var scrollPosition = document.documentElement.scrollTop || document.body.scrollTop;
    for (i in sections) {

      if (sections[i] <= scrollPosition) {
        $(".m09-parent").find('a[href*=' + i + ']').siblings().removeClass('active');
        $(".m09-parent").find('a[href*=' + i + ']').addClass('active');
        $(".m09-parent").find("#m09-select").val(i);
      }
    }
  };
})

const app = {
  newsletter: {
    init: function() {
      const newsletterBar = document.querySelector('.newsletter-section'),
        currentUrl = window.location.href,
        url = new URL(currentUrl),
        isCustomerPosted = url.searchParams.get('customer_posted');
      if (newsletterBar && isCustomerPosted == "true") {
        setTimeout(function() {
          $("html, body").animate({
            scrollTop: $(newsletterBar).offset().top - 180 
          }, 300);
        }, 1000);
      }
    }
  },
  init: function() {
    this.newsletter.init();
  }
}
window.app = app;
window.addEventListener('DOMContentLoaded', function() {
  app.init();
  initDecrementQuantityButtons();
});

// Cookies 
function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  let expires = "expires="+d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  let name = cname + "=";
  let ca = document.cookie.split(';');
  for(let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

// Function to send POST request with retry mechanism
async function sendPostRequestWithRetry(url, data, maxRetries = 3, delay = 1000) {
  for (let attempt = 1; attempt <= maxRetries; attempt++) {
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) throw new Error(`Server error: ${response.status}`);

      const result = await response.json();
      return result;
    } catch (error) {
      console.error(`Attempt ${attempt} failed: `, error);

      if (attempt < maxRetries) {
        const retryDelay = delay * Math.pow(2, attempt - 1); // Exponential backoff
        await new Promise((resolve) => setTimeout(resolve, retryDelay));
      } else {
        console.error("All retry attempts failed.");
      }
    }
  }
}

// On cart page, update cart line items with _collectionIds property
document.addEventListener("DOMContentLoaded", () => {
  if (window.location.pathname.includes("/cart")) {
    const lineItemInputs = document.querySelectorAll('input[name="line_item_properties"][type="hidden"]');

    lineItemInputs.forEach((input) => {
      const itemValue = input.value;

      if (itemValue) {
        const parsedItemValue = JSON.parse(itemValue);

        sendPostRequestWithRetry(
          "/cart/change.js",
          { id: parsedItemValue.id, properties: parsedItemValue.properties }
        );
      }
    });
  }
});
